import React from 'react';
import { useUpgradeAction } from '../hooks/useUpgradeAction';

/**
 * Inline "Upgrade" affordance for a paywalled strip inside an otherwise
 * accessible page.
 *
 * Renders a button rather than an `<a href={UPGRADE_URL}>`: a raw link dropped
 * the user on the public pricing page, where an existing subscriber has no way
 * to change plan and simply bounces. `useUpgradeAction` sends them to their
 * Stripe billing portal instead, and only falls back to the marketing page
 * when no Stripe customer is linked to the account.
 */
export const UpgradeLink: React.FC = () => {
  const { onUpgrade, isRedirecting } = useUpgradeAction(true);

  return (
    <button
      type="button"
      onClick={onUpgrade}
      disabled={isRedirecting}
      className="text-accent-yellow hover:underline disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {isRedirecting ? 'Redirecting…' : 'Upgrade'}
    </button>
  );
};
